export const STORAGE_KEY = 'redirectToMtDate'

export const TIMEOUT_DELAY = 20000

export const CUSTOM_EVENTS = {
  noRedirect: 'auto-redirect-to-mt:no-redirect',
}
